"use client";

import { useState } from "react";
import Image from "next/image";
import ImageLightbox from "./ImageLightbox";

export default function AwardImage() {
  const [open, setOpen] = useState(false);
  const src = "/images/cert-steam-2025.webp";
  const alt =
    "Chứng nhận Top 20 AI For SuperTeachers Award - Nguyễn Lê Giang - STEAMese Festival 2025";

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="relative rounded-xl overflow-hidden bg-white border border-border shadow-card-md min-h-[220px] hover:border-orange-400 hover:shadow-card-lg transition-all cursor-zoom-in w-full"
        aria-label="Phóng to chứng nhận"
      >
        <Image
          src={src}
          alt={alt}
          fill
          className="object-contain p-3"
          sizes="(max-width: 1024px) 100vw, 280px"
        />
      </button>

      <ImageLightbox src={open ? src : null} alt={alt} onClose={() => setOpen(false)} />
    </>
  );
}
